<template>
  <div id="app">
    <ComponentHeader />
    <Content />
    <ComponentFooter />
  </div>
</template>

<script>
import ComponentHeader from './components/ComponentHeader.vue'
import ComponentFooter from './components/ComponentFooter.vue'
import Content from './components/Content.vue'

export default {
  name: 'App',
  components: {
    ComponentHeader,
    ComponentFooter,
    Content
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
